import React, { useState } from "react";
import useAuth from "./Hooks/useAuth";
import useDeployments from "./Hooks/useDeployments";
import DeploymentCard from "./Components/MonitorDeployments/DeploymentCard";
import PageHeader from "./Components/Navigation/PageHeader";
import SkeletonCard from "./Components/MonitorDeployments/DeploymentCardSkeleton";
import NoDeploymentsMessage from "./Components/MonitorDeployments/NoDeploymentsMessage";
import useNotificationPermission from "./Hooks/NotificationPermission";
import FaviconBadge from "./Components/FaviconBadge";
import "react-toastify/dist/ReactToastify.css";

function ArchivePage() {
  const { user, signIn } = useAuth();
  const [filter, setFilter] = useState("all"); // State for filtering deployments
  const [searchTerm, setSearchTerm] = useState("");
  const [processingRestore, setProcessingRestore] = useState(false);
  
  // Only fetch archived deployments from the archive table
  const { deployments, initialLoad, setDeployments } = useDeployments(user, true); // true indicates archived deployments

  // Use custom hooks
  useNotificationPermission();

  // Filter deployments based on the search term and filter criteria
  const filteredDeployments = deployments
    .filter((deployment) => deployment.isArchive) // Ensure only archived deployments are shown
    .filter((deployment) => {
      if (filter === "running") {
        return deployment.percentComplete < 100; // Running deployments
      } else if (filter === "complete") {
        return deployment.percentComplete === 100; // Completed deployments
      } else {
        return true; // Show all archived deployments
      }
    })
    .filter(
      (deployment) =>
        deployment.companyCode
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        deployment.machineName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        deployment.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        deployment.companyName
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    );

  return (
    <>
      <title>JimmyBot - Archived Deployments</title>
      <PageHeader
        iconName="Archives"
        placeholderText="Search Archived Deployments"
        user={user}
        signIn={signIn}
        setSearchTerm={setSearchTerm}
        filter={filter} // Pass the filter state
        setFilter={setFilter} // Pass the function to change the filter state
        showArchive={false} // Not needed here
        title="View Archived Deployments"
      />
      <div
        style={{
          padding: "16px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          {initialLoad || processingRestore ? (
            Array.from({ length: 12 }).map((_, index) => (
              <div
                key={index}
                style={{
                  flex: "0 1 375px",
                }}
              >
                <SkeletonCard />
              </div>
            ))
          ) : filteredDeployments.length > 0 ? (
            filteredDeployments.map((deployment) => (
              <div
                key={deployment.id}
                style={{
                  flex: "0 1 375px",
                }}
              >
                <DeploymentCard
                  deployment={deployment}
                  setDeployments={setDeployments}
                  isArchived={deployment.isArchive}
                  setProcessingRestore={setProcessingRestore}
                />
              </div>
            ))
          ) : (
            <NoDeploymentsMessage Message="No Archived Deployments Found" />
          )}
        </div>
      </div>

      {/* Badge for Favicon */}
      <FaviconBadge count={filteredDeployments.length} />
    </>
  );
}

export default ArchivePage;
